import './components/share'

import './scss/st14/styles.scss'
